import React from 'react'
import { buildImageObject, blockContentToText } from "../utilities/helpers"
import { imageUrlFor } from '../utilities/image-url'

import Marker from '../../static/images/card-marker.inline.svg'
import { Link } from 'gatsby';

import ClampLines from 'react-clamp-lines';

const ActivityCard = ({
  id,
  document_id,
  title,
  slug,
  image,
  description,
  category,
  organizer
}) => {
  const formatter = new Intl.ListFormat('no', { style: 'long', type: 'conjunction' });
  const organizers = organizer && organizer.map((organizer) => {
    return organizer.name;
  })

  return (
    <div className={`${category?.colors?.title} flex flex-col p-[24px] text-small md:text-small-md relative` } key={id}>
      {image && image.asset && (
        <Link to={`/aktiviteter/${slug.current}/`} className={`mb-[16px] activity-image flex items-center justify-center`}>
          <figure className={``}>
            <img
              src={imageUrlFor(buildImageObject(image)).url()}
              alt={image.alt}
              className={`max-h-[180px] max-w-[180px] w-full h-full`}
            />
          </figure>
        </Link>
      )}
      <div className={`flex mb-[16px]`}>
        <div className={`bg-black text-white rounded-full flex items-center justify-center w-[2em] h-[2em] text-[18px] font-bold absolute inset-[24px]`}>
          {document_id}
        </div>
        <div className={`flex-1`}>
          <Link to={`/aktiviteter/${slug.current}/`}>
            <h3 className={`text-h4 md:text-h4-md font-bold mb-0`}>{title}</h3>
          </Link>
          {organizers && (
            <p>av {formatter.format(organizers)}</p>
          )}
        </div>
      </div>
      <div className={`flex-auto mb-[16px]`}>
        {description && (
          <ClampLines text={blockContentToText(description)} buttons={false} innerElement="p" />
        )}
      </div>
      <div className={`grid grid-cols-2`}>
        {category && category.title && (
          <Link to={`/kart/${slug.current}`} className={`text-small md:text-small-md flex items-center`}>
            <Marker />
            <span className={`ml-[4px]`}>
                {category?.title}
            </span>
          </Link>
        )}
        <div className={`flex justify-end`}>
          <Link
            className={`p-[12px_16px] rounded-[8px] bg-black bg-opacity-80 text-base md:text-[17px] text-white`}
            to={`/aktiviteter/${slug.current}/`}
          >
            <span>Mer info</span>
          </Link>
        </div>
      </div>
    </div>
  )
}

export default ActivityCard
